// FieldIQ — "Ask about person" bridge
// Lets deeply nested views (e.g. VoterInfoPanel inside a walk) open the chat
// tab pre-filled with a person's name. AppShell registers the handler; callers
// invoke askAboutPerson(name). Replaces the old module-level `_askAboutPerson`.

let _handler = null;

export const setAskAboutPersonHandler = (fn) => {
  _handler = fn;
};

export const askAboutPerson = (name) => {
  _handler?.(name);
};
